import { createFileRoute } from '@tanstack/react-router';
import { ModeliaPage } from '@/domains/credit';

// Ruta estática: gana sobre la dinámica hermana `$section` (que sigue cubriendo el resto).
export const Route = createFileRoute('/_backoffice/credit/modelia')({
    component: CreditModelia,
});

function CreditModelia() {
    return <ModeliaPage />;
}
